import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";
import type { NoticeDTO } from "../../shared/dto";
import { uploadsUrl } from "../lib/uploader";
import { fmtDate, isWithinDays } from "../lib/format";
import {
  SectionHeading,
  StatusBadge,
  Loading,
  EmptyState,
} from "../components/ui";

export function NoticesPage() {
  const [items, setItems] = useState<NoticeDTO[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api
      .get<{ items: NoticeDTO[] }>("/notices")
      .then((r) => setItems(r.items))
      .finally(() => setLoading(false));
  }, []);

  const now = Date.now();

  return (
    <div>
      <SectionHeading level={2}>お知らせ</SectionHeading>
      {loading ? (
        <Loading />
      ) : items.length === 0 ? (
        <EmptyState
          icon="📢"
          title="お知らせはありません"
          description="新しいお知らせが届くとここに表示されます。"
        />
      ) : (
        <div className="card overflow-hidden">
          {items.map((n, i) => {
            const isNew = isWithinDays(n.publishedAt, 7);
            const thumb = uploadsUrl(n.thumbnailKey);
            return (
              <Link
                key={n.id}
                to={`/notices/${n.id}`}
                className={`flex items-center gap-4 px-6 py-5 group transition-colors hover:bg-black/[0.02] ${
                  i > 0 ? "border-t border-black/5" : ""
                }`}
              >
                {thumb ? (
                  <img
                    src={thumb}
                    alt=""
                    className="shrink-0 w-16 h-16 rounded-lg object-cover border border-black/10 bg-black/5"
                  />
                ) : (
                  <div className="shrink-0 w-16 h-16 rounded-lg border border-black/10 bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center text-2xl">
                    📢
                  </div>
                )}
                {n.publishedAt && (
                  <span className="text-sm text-tora-ink/50 tabular-nums shrink-0 w-24">
                    {fmtDate(n.publishedAt)}
                  </span>
                )}
                {isNew ? (
                  <span className="shrink-0 inline-block rounded-full bg-tora text-white text-[11px] font-bold px-3 py-0.5">
                    NEW
                  </span>
                ) : (
                  <span className="shrink-0 w-12" />
                )}
                <span className="flex-1 text-base md:text-lg font-bold text-tora-ink leading-snug group-hover:text-tora transition-colors truncate">
                  {n.title}
                </span>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
